var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.561 32.561C22.268 32.854 21.884 33 21.5 33C21.116 33 20.732 32.854 20.439 32.561L15.439 27.561C14.853 26.975 14.853 26.026 15.439 25.44C16.025 24.854 16.974 24.854 17.56 25.44L21.499 29.379L41.551 9.328C40.707 7.373 38.761 6 36.5 6H11.5C8.468 6 6 8.468 6 11.5V36.5C6 39.532 8.468 42 11.5 42H36.5C39.532 42 42 39.532 42 36.5V13.121L22.561 32.561Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBox);
export default __webpack_public_path__ + "static/media/tick-box.1b42014c0da17a0a094c4caec35b8f4f.svg";
export { ForwardRef as ReactComponent };